import { Controller } from "stimulus";
// import $ from 'jquery';
const $ = window.jQuery;
import 'toastr/toastr.scss';
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import { OpenStreetMapProvider } from 'leaflet-geosearch';

const provider = new OpenStreetMapProvider();

export default class extends Controller {
    static targets = ["container"];
    static values = {
        icon: String
    };

    offices = [];
    popup;
    marker;

    connect() {
        this.createMap();
        this.map.setView([23.136667, -82.358889], 7);

        const activeOfficesUrl = this.data.get("active_offices_url");
        this.loadOffices(activeOfficesUrl);

        $(document).on('click', '.office', (event) => this.handleOfficeClick(event));
    }

    createMap() {
        this.map = L.map(this.containerTarget, {
            attribution: false,
            attributionControl: false,
            dragging: false,
            interactive: false,
            scrollWheelZoom: false,
            zoomControl: false
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            zoom: 17,
            minZoom: 7,
            maxZoom: 19,
            zoomSnap: 0.25,
            touchZoom: false,
        }).addTo(this.map);
    }

    loadOffices(url) {
        $.blockUI({ message: false });
        $.ajax({
            url: url,
            type: "GET",
            success: (res) => {
                $.unblockUI();
                if (res && res.offices) {
                    this.renderOffices(res.offices);
                }
            },
            error: (xhr, status, error) => {
                $.unblockUI();
                console.error("Error loading offices:", error);
            }
        });
    }

    renderOffices(offices) {
        $("#active_offices").empty();
        Object.entries(offices).forEach(([destinationName, dealers]) => {
            const destinationContainerId = `${destinationName.toLowerCase().replaceAll(' ', '-')}-dealers`;
            $("#active_offices").append(
                `<details>
                    <summary><strong>${destinationName}</strong></summary>
                    <div id="${destinationContainerId}" class="pl-3"></div>
                </details>`
            );

            Object.entries(dealers).forEach(([dealerName, offices]) => {
                const dealerContainerId = `${destinationContainerId}-${dealerName.toLowerCase().replaceAll(' ', '-')}-offices`;
                const color = dealerName.includes('REX') ? 'rgba(239, 64, 53, 1)' : '#0056a3';
                $(`#${destinationContainerId}`).append(
                    `<details>
                        <summary style="color: ${color};"><strong>${dealerName}</strong></summary>
                        <div id="${dealerContainerId}" class="pl-3"></div>
                    </details>`
                );

                offices.forEach(office => {
                    this.offices.push(office);
                    $(`#${dealerContainerId}`).append(
                        `<div>
                            <strong class="text-dark office" role="button"
                                data-id="${office.id}"
                                data-latitude="${office.latitude}"
                                data-longitude="${office.longitude}"
                                data-name="${office.name}"
                                data-phone="${office.phones}"
                                data-optime="${office.open_time}"
                                data-cltime="${office.close_time}"
                                data-fulltime="${office.full_time}"
                                data-address="${office.address}"
                            >${office.name}</strong>
                        </div>`
                    );
                });
            });
        });
    }

    handleOfficeClick(event) {
        const { latitude, longitude, id, name, phone, optime, cltime, address, fulltime } = event.target.dataset;
        const latLng = L.latLng(latitude, longitude);
        const office = this.offices.find(office => String(office.id) === id);

        if (latitude == 0.0 && longitude == 0.0) {
            this.map.setView([23.136667, -82.358889], 7);
            this.clearMarker();
        } else {
            this.addMarker(latLng, name, phone, optime, cltime, address, fulltime);
            this.map.setView([latitude, longitude], 17);
        }

        this.renderOfficeCard(name, phone, optime, cltime, address, fulltime, office.product_types);
    }

    setPopupContent(name, phone, optime, cltime, address, fulltime) {
        const content = fulltime ?
            `<h4>${name}</h4><br>
             <b><span>Contacto: </span></b>${phone}<br>
             <b><span>Horario: </span></b>24 Horas<br>
             <b><span>Dirección: </span></b>${address}<br>` :
            `<h4>${name}</h4><br>
             <b><span>Contacto: </span></b>${phone}<br>
             <b><span>Apertura: </span></b>${optime} &nbsp; <b><span>Cierre: </span></b>${cltime}<br>
             <b><span>Dirección: </span></b>${address}<br>`;

        this.marker.bindPopup(content).openPopup();
    }

    addMarker(latLng, name, phone, optime, cltime, address, fulltime) {
        this.clearMarker();

        const myIcon = L.icon({
            iconUrl: this.iconValue,
            className: 'pin-map',
            popupAnchor: [-3, -3],
            iconSize: [20, 30]
        });

        this.marker = L.marker(latLng, { icon: myIcon }).addTo(this.map);
        this.setPopupContent(name, phone, optime, cltime, address, fulltime);
    }

    clearMarker() {
        if (this.marker) {
            this.marker.remove();
            this.marker = null;
        }
    }

    renderOfficeCard(name, phone, optime, cltime, address, fulltime, productTypes) {
        const officeProductType = productTypes.map(product => product.name).sort().join(", ");
        const schedule = fulltime ? "24 Horas" : `Apertura: ${optime} &nbsp; Cierre: ${cltime}`;

        $(".mapcard").empty().append(
            `<div class="mt-3 row">
                <div class="col-md-6">  
                    <label class="form-label">Nombre:</label>
                    <blockquote>${name}</blockquote>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Productos:</label>
                    <blockquote>${officeProductType}</blockquote>
                </div>
                <div class="col-md-6 activetime">
                    <label class="form-label">Horario:</label>
                    <blockquote>${schedule}</blockquote>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Teléfono de Contacto:</label>
                    <blockquote>${phone}</blockquote>
                </div>
                <div class="col-md-12">
                    <label class="form-label">Dirección:</label>
                    <blockquote>${address}</blockquote>
                </div>
            </div>`
        );
    }

    disconnect() {
        this.map.remove();
    }
}